import { render, staticRenderFns } from "./FormIELTS.vue?vue&type=template&id=40e449e6&scoped=true&lang=pug"
import script from "./FormIELTS.vue?vue&type=script&lang=ts"
export * from "./FormIELTS.vue?vue&type=script&lang=ts"
import style0 from "./FormIELTS.vue?vue&type=style&index=0&id=40e449e6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e449e6",
  null
  
)

/* custom blocks */
import block0 from "./FormIELTS.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fmodules%2FDocuments%2Fcomponents%2Fforms%2FIELTS%2FFormIELTS.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports